import { extractChannelId } from "@/lib/ws/routing";

const TELEMETRY = "telemetry";

function asRecord(msg: unknown): Record<string, unknown> | null {
  if (!msg || typeof msg !== "object" || Array.isArray(msg)) {
    return null;
  }
  return msg as Record<string, unknown>;
}

function readDeviceId(o: Record<string, unknown>): string | undefined {
  const a = o.device_id;
  const b = o.deviceId;
  if (typeof a === "string") {
    return a;
  }
  if (typeof b === "string") {
    return b;
  }
  return undefined;
}

/**
 * Parse websocket JSON for channel `telemetry` — returns unix seconds + numeric fields.
 */
export function parseTelemetryStreamPoint(
  msg: unknown,
  deviceId: string,
  metricKeys: string[],
): { t: number; values: number[] } | null {
  if (extractChannelId(msg) !== TELEMETRY) {
    return null;
  }
  const o = asRecord(msg);
  if (!o) {
    return null;
  }
  if (readDeviceId(o) !== deviceId) {
    return null;
  }
  const rawTime = o.time ?? o.t ?? o.timestamp;
  let tsec: number;
  if (typeof rawTime === "string") {
    tsec = new Date(rawTime).getTime() / 1000;
  } else if (typeof rawTime === "number") {
    tsec = rawTime > 1e12 ? rawTime / 1000 : rawTime;
  } else {
    tsec = Date.now() / 1000;
  }
  const payload = o.data ?? o.payload ?? o;
  const pod = asRecord(payload);
  const values = metricKeys.map((k) => {
    if (!pod) {
      return NaN;
    }
    const v = pod[k];
    if (typeof v === "number") {
      return Number.isNaN(v) ? NaN : v;
    }
    if (typeof v === "string") {
      const n = Number(v);
      return Number.isNaN(n) ? NaN : n;
    }
    return NaN;
  });
  return { t: tsec, values };
}
